import { useEngagementContext } from './engagement.provider';
import { useState, useEffect } from 'react';
import { trackError } from '~/services/logger/error.utils';

interface IsEligibleProps {
    feature: string;
    check: string;
}

export const useIsEligible = ({ feature, check }: IsEligibleProps) => {
    const { eligibilityService } = useEngagementContext();
    const [isEligible, setIsEligible] = useState<boolean | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const checkEligibility = async () => {
        try {
            setIsLoading(true);
            const { is_eligible } = await eligibilityService.checkEligibility(
                feature,
                check
            );
            setIsEligible(is_eligible);
        } catch (error) {
            trackError({
                error,
                message: 'Error checking eligibility',
                context: { feature, check }
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        void checkEligibility();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { isEligible, isLoading };
};
